import React from 'react';
import {useConsent} from './ConsentContext';
import './ConsentBanner.css';

export default function ConsentBanner() {
    const {googleMaps, chooseGoogleMaps, settingsOpen, setSettingsOpen} = useConsent();
    if (googleMaps !== null && !settingsOpen) return null;

    return (
        <section className="bioretis-consent-banner" role="region" aria-label="Privacy preferences">
            <div className="bioretis-consent-banner__content">
                <strong>Your privacy matters</strong>
                <p>
                    We use technologies necessary for the operation of this website.
                    With your consent, we also load Google Maps to display an interactive map.
                    This may transfer personal data to Google and allow Google to use cookies
                    or similar technologies. Google Maps remains disabled unless you agree.
                    You can change your choice at any time under Cookie Settings.
                    {' '}<a href="/privacy">Privacy Policy</a>
                </p>
            </div>
            <div className="bioretis-consent-banner__actions">
                <button type="button" onClick={() => chooseGoogleMaps(false)}>
                    Essential only
                </button>
                <button type="button" className="bioretis-consent-banner__accept" onClick={() => chooseGoogleMaps(true)}>
                    Accept all
                </button>
                {settingsOpen && googleMaps !== null && (
                    <button type="button" className="bioretis-consent-banner__close" onClick={() => setSettingsOpen(false)}>
                        Close
                    </button>
                )}
            </div>
        </section>
    );
}
